import { RouteConfig } from 'vue-router'

export const IndexRoute: RouteConfig = {
  path: '/activity/winter-points-2025',
  name: 'activity_winter_points_2025',
  component: () => import('./winter-points/Index.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '寒假体育作业学生积分活动',
  },
}

export const WinnersRoute: RouteConfig = {
  path: '/activity/winter-points-2025/winners',
  name: 'activity_winter_points_2025_winners',
  component: () => import('./winter-points/winners.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '中奖名单公示',
  },
}

export const FortuneRecordsRoute: RouteConfig = {
  path: '/activity/winter-points-2025/fortune-records',
  name: 'activity_winter_points_2025_fortune_records',
  component: () => import('./winter-points/FortuneRecords.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '好运明细',
  },
}

export const AuctionRecordsRoute: RouteConfig = {
  path: '/activity/winter-points-2025/auction-winners',
  name: 'activity_winter_points_2025_auction_winners',
  component: () => import('./winter-points/AuctionWinners.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '中奖名单公示',
  },
}

export default [IndexRoute, WinnersRoute, FortuneRecordsRoute, AuctionRecordsRoute]
